import { IconButton, InputBase, Typography } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import CustomButtonSmall from "../../components/CustomButtonSmall";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import SearchIcon from "@mui/icons-material/Search";

import { 
  globalSearchText, 
  selectedItems,
  showErrorAlertDialog, 
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  SOME_ERROR_OCCURRED,
  ERROR,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";

// API Services
import { 
  getAddDealerDropdownDetails,
 } from "../../services/ApiService";

import { useLocation, useNavigate } from "react-router-dom";
import { allAccountsCreditDebitColumnHeader } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import { CustomToolbarWithoutExport } from "../../components/DataGridCustomToolBarWithoutExport";
import { debitCreditFilterItemsDetails } from "../../data/freezeFilterItems";

export function AddDealerScreenCreditDebit() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();
  const dataProps = location.state && location.state.data;
  const flowProp = location.state && location.state.type;

  const isNetworkConnectionAvailable = UseOnlineStatus();

  // filterCriteria is fetched from API and has the structure of [{ "displayName": "NAME", "paramName": "accountName" }]
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([{ "keyValue":"","displayName": "", "paramName": "" }]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState(""); 
  const [getProgressbarText, setProgressbarText] = useState("");
  const [dealerDetails, setDealerDetails] = useState([]);

  //const [earmarkDetails, setEarmarkDetails] = useState([]);
  const [searchInitiated, setSearchInitiated] = useState(false);
  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(25);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [searchQueryPlaceholder, setSearchQueryPlaceholder] = useState("Search Name");
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  const [searchDealerQuery, setDealerSearchQuery] = useState(""); //useAtom(globalSearchText);

  // Add Earmark Dialog
  const [openAddEarmarkDialog, setOpenAddEarmarkDialog] = useState(false);
  const [selectedDealerName, setSelectedDealerName] = useState("");
  const [selectedDealerCode, setSelectedDealerCode] = useState("");

  // Save and Remove Earmark Dialog
  const [openSaveAndRemoveEarmarkDialog, setOpenSaveAndRemoveEarmarkDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [earmarkTimelineDetails, setearmarkTimelineDetails] = useState([]);
  const [flowType, setFlowType] = useState("");

  const [formData, setFormData] = useState({
    dealer: "",
    type: "",
    description: "",
    amount: "",
    option:"",
    date: "",
    refrenceNo: "",
    id:"",
    reason: "",
  });

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 56; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= paginationModel.pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }
    const totalHeight = headerHeight + (rowCount+1) * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }
  
  // call only on the first time page is rendered
  useEffect(() => {
    getCreditDebitFilterDetails();
    DebugLog(JSON.stringify({ dataProps }));

    setFormData(dataProps)
    setFlowType(flowProp)

  }, []);

  useEffect(() => {

    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  // create useEffect to clear search query when a new filter is selected
  useEffect(() => {
    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    // setSearchQuery("");
  }, [filter]);

  const handleOpen = () => {
    setOpenAddEarmarkDialog(true);
  };
  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find((item) => item.displayName === filter);
    setFilter(selectedFilter);

  };

  const handleClose = () => {
    setOpenAddEarmarkDialog(false);
    DebugLog("Dialog Closed");
  };
  
  const handleCloseSaveAndRemoveEarmarkDialog = () => {
    setOpenSaveAndRemoveEarmarkDialog(false);
    DebugLog("Dialog Closed");
  };

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    // Avoid using state directly for API call as the state update function is async. 
    // Means it will not update the state immediately and it will be using the old state value.
    searchAccountDetails(newPage, paginationModel.pageSize);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    searchAccountDetails(newPage, paginationModel.pageSize);
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0. 
    searchAccountDetails(0, newPageSize);
  }

  
  const renderButton = (rowData) => {
    return <CustomButtonSmall
    btnBG={colors.primary[100]}
    btnColor={colors.grey[900]}
    btnTxt={"Add Dealer"}
    btnBorder={"1px solid"+colors.primary[100]}
    onClick={() => handleAddNewDealerClick(rowData)}
    ></CustomButtonSmall>
  };

  const handleAddNewDealerClick = (rowData) => {
    DebugLog("form data  "+JSON.stringify({ formData }));
   // editAllowed === null || editAllowed === true
  let value = {};
     if(formData!==null){
       value = {
        name: rowData.accountName!==null ? rowData.accountName : "",
        code: rowData.accountCode!==null ? rowData.accountCode : "",
        type: formData.type!==null ? formData.type : "",
        details: formData.details!==null ? formData.details : "",
        amount: formData.amount!==null ? formData.amount : "",
        status: formData.status!==null ? formData.status : "",
        date: formData.date!==null? formData.date : "",
        refrenceNo: formData.refrenceNo!==null? formData.refrenceNo : "",
        reason:formData.reason!==null ? formData.reason : "",
        id:formData.id!==null ? formData.id : "",
        isEditable:formData.isEditable!=null ? formData.isEditable :""
      };
     } else {
       value = {
        name: rowData.accountName!==null ? rowData.accountName : "",
        code: rowData.accountCode!==null ? rowData.accountCode : "",
        type:  "",
        details:  "",
        amount: "",
        status: "",
        date:  "",
        refrenceNo: "",
        reason:"",
        id:"",
        isEditable:""
      };
     }
   
    setFormData(value);
    DebugLog("flowProp >> "+flowType)

    navigate(CONSTANT.ADD_ADJUSTMENTS_ROUTE, { state: { data: value ,type : flowType} })
   
  };


  function addDealerSearchButtonClicked() {
    if(searchDealerQuery===""){
      showErrorAlert(
        "Alert",
        "Please enter some value!"
      );
    }else{
      searchAccountDetails(paginationModel.page, paginationModel.pageSize);
    }
   
  }


 


  

  // create a function to call api getCreditDebitFilterDetails to get filter criteria for the dropdown
  async function getCreditDebitFilterDetails() {
    setFilterCriteria(debitCreditFilterItemsDetails.result);
    setFilterDisplayOptions(
      debitCreditFilterItemsDetails.result.map((item) => item.displayName)
    );
    setDefaultFilter(debitCreditFilterItemsDetails.result[0].displayName);
    setFilter(debitCreditFilterItemsDetails.result[0]);

    setDefaultFilter("companyName");
  }

  // search accounts after user click search button
  function searchAccountDetails(pageNumber, pageSize) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

      //   const requestObject = createRequestObject(
      //     pageNumber,
      //     pageSize,
      //     filter,
      //     searchDealerQuery
      // );

        const requestObject = {
            searchKeyword : searchDealerQuery,
            pageNumber: pageNumber,
            pageSize: pageSize,
          };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ALL_ACCOUNTS_CREDIT_DEBIT_DETAILS_SEARCH
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getAddDealerDropdownDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.dealers.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
                setDealerDetails(contentData);
               setRowsPerPage(response.data.result.dealers.content.length);
               setTotalNoOfRows(response.data.result.dealers.totalElements);
               setTotalNoOfPages(response.data.result.dealers.totalPages);

              setSearchInitiated(true);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });

          setLoading(false);
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for searchAccountDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
   
    let requestObject = {
      companyName: null,
      companyCode: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      vendorCode: null,
      sortOrder: null,
      sortProperty: null,
      
    };
  
    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter.paramName != "") {
      requestObject[selectedFilter.paramName] = filterValue;
    }

    return requestObject;
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    } 

    const errorCode = error.data?.errorCode;
    var errorMessage =
        error.response != null
            ? error.displayErrorMessage
            : 'Unknown';
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () => navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () => showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
      ),
    };
  
    (errorActions[errorCode] || errorActions.default)();
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  return (
      /* Main Container */
      <Box>
          <SnackbarProvider maxSnack={3}>
              <ConnectionStatus />

              {/* <AddEarmarkDialogInput
                  open={openAddEarmarkDialog}
                  onClose={handleClose}
                  dealerName={selectedDealerName}
                  onSubmit={addNewEarmark}
              /> */}

              <ShowErrorAlertDialog
                  status={getDialogStatus}
                  title={title}
                  content={content}
              />

              {/* <SaveAndRemoveEarmarkDialog
                  open={openSaveAndRemoveEarmarkDialog}
                  onClose={handleCloseSaveAndRemoveEarmarkDialog}
                  onDialogButtonClick={requestUpdateEarMarkDetailsData}
                  onDialogRemoveButtonClick={requestDeleteEarMarkDetailsData}
                  data={selectedItem}
                  earmarkTimeline={earmarkTimelineDetails}
              /> */}

              {isNetworkConnectionAvailable ? (
                  <CustomProgressDialog
                      open={loading}
                      text={getProgressbarText}
                  />
              ) : (
                  showNoInternetSnackBar()
              )}
              <Grid
                  container
                  component="main"
                  direction={'column'}
                  sx={{
                      // height: "100vh",
                      m: '0 2.5%' /* Approx 30px */,
                      borderRadius: '18px',
                  }}
              >
                  {/* Header */}
                  <Grid
                      container
                      direction={'row'}
                      alignItems={'center'}
                      mb={2}
                      ml={2}
                      mt={1}
                  >
                      <Grid item mr={2}>
                          <IconButton href={CONSTANT.ADD_ADJUSTMENTS_ROUTE} width={12}>
                              <img
                                  src={'../../assets/common/Back.svg'}
                                  width={12}
                              />
                          </IconButton>
                      </Grid>

                      <Grid item>
                          <Typography
                              color={colors.grey[100]}
                              fontWeight={'600'}
                              variant="h3"
                          >
                              {'Add Dealer'}
                          </Typography>
                      </Grid>

                      <Box position="absolute" right={30} top={100}>
                          <Grid
                              container
                              direction={'row'}
                              alignItems={'center'}
                          >
                              {/* SEARCH BAR */}
                              <Box
                                  backgroundColor={colors.grey[900]}
                                  borderRadius="20px"
                                  ml={5}
                                  mr={2}
                              >
                                  <InputBase
                                      sx={{ ml: 2, flex: 1 }}
                                      placeholder={searchQueryPlaceholder}
                                      value={searchDealerQuery}
                                      onChange={(e) =>
                                          setDealerSearchQuery(e.target.value)
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          addDealerSearchButtonClicked();
                                          e.preventDefault(); // Prevent form submission & page refresh
                                        }
                                      }}
                                  />

                                  <IconButton type="button" sx={{ p: 1 }}>
                                      <SearchIcon
                                          onClick={addDealerSearchButtonClicked}
                                      />
                                  </IconButton>
                              </Box>

                              {/* <ToolbarFilterButton
                                  options={filterDisplayOptions}
                                  defaultOption={defaultFilter}
                                  onChange={handleFilterChange}
                                  name={"FILTERS"}
                               /> */}
                               
                          </Grid>
                      </Box>
                  </Grid>
                  {/* Header */}

                  {/* On Hold Section */}
                  <Grid
                      container
                      mt={3}
                      border={'1px solid' + colors.grey[600]}
                      borderRadius={3}
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      pb={2}
                  >

                      {/* only show data after first search was initiated */}
                      {!searchInitiated ? (
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="450px"
                          width="100%"
                        >
                          <Typography variant="h6" align="center">
                            Search results will be displayed here.
                          </Typography>
                        </Box>
                      ) : dealerDetails.length > 0 ? (
                            <Box
                                borderRadius={3}
                                flex={1}
                                m="0px 0 0 0"
                                pb={0}
                                height={gridHeight}
                                sx={{
                                    '& .MuiDataGrid-root': {
                                        border: 'none',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        borderBottom: 'none',
                                    },
                                    '& .name-column--cell': {
                                        color: colors.redAccent[200],
                                        fontWeight: 'bold',
                                        fontSize: 13,
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: 'rgba(255,255,255,0.6)',
                                        borderBottom: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '13px',
                                        color: `${colors.grey[300]} !important`,
                                    },
                                    '& .MuiDataGrid-virtualScroller': {
                                        background: 'rgba(255,255,255,1)',
                                    },
                                    '& .MuiDataGrid-footerContainer': {
                                        borderTop: 'none',
                                        backgroundColor: 'rgba(255,255,255,0.6)',
                                    },
                                    '& .MuiCheckbox-root': {
                                        //color: `${colors.white[200]} !important`,
                                    },
                                    '& .MuiDataGrid-toolbarContainer .MuiButton-text':
                                        {
                                            //  color: `${colors.grey[100]} !important`,
                                            //backgroundColor: "rgba(255,255,255,0.6)",
                                            // opacity:.5
                                        },
                                }}
                            >
                                <DataGrid
                                   
                                    rows={dealerDetails}
                                    columns={allAccountsCreditDebitColumnHeader(
                                        renderButton
                                    )}
                                    components={{ Toolbar: CustomToolbarWithoutExport }}
                                    checkboxSelection={false}
                                    selecion
                                    pageSize={pageSize}
                                    pageSizeOptions={[25, 50, 100]}
                                    rowCount={totalNoOfRows}
                                    paginationModel={paginationModel}
                                    paginationMode="server"
                                    keepNonExistentRowsSelected
                                    onPageChange={handlePageChange}
                                    onPageSizeChange={handlePageSizeChange}
                                    //onRowClick={handleRowClick}
                                    autoHeight
                                />
                            </Box>
                        ) : (
                            NoDataFound()
                        )}
                  </Grid>

                  {dealerDetails.length > 0 ? (
                      <Box>
                          <Typography>
                              <span>Jump to page: </span>
                              <select
                                  value={paginationModel.page + 1}
                                  onChange={handlePageJump}
                              >
                                  {[...Array(totalNoOfPages)].map(
                                      (_, index) => (
                                          <option key={index} value={index + 1}>
                                              {index + 1}
                                          </option>
                                      )
                                  )}
                              </select>
                          </Typography>
                      </Box>
                  ) : (
                      ''
                  )}
                  <UserActivityInfo />
              </Grid>
          </SnackbarProvider>
      </Box>
      /* Main Container */
  );
}
